import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Space } from 'antd';
import { MdRefresh, MdOutlineEventNote } from 'react-icons/md';
import { GrConfigure } from 'react-icons/gr';
import WhenDesktop from 'src/components/layout/WhenDesktop';
import SecurityAdvisorContext from 'src/context/SecurityAdvisorContext';
//import PropTypes from 'prop-types';

const EventsWidgetBtns = () => {
  const navigate = useNavigate();
  const { eventWidgetItems, eventWidgetItemsForceReload, setEventWidgetItemsForceReload, ebIntegrationInstalled } = useContext(SecurityAdvisorContext);

  return (
    <>
      {false === ebIntegrationInstalled && (
        <Space>
          <Button
            size='small'
            onClick={() => {
              navigate('/security-advisor/events');
            }}
          >
            <Space className='btn'>
              <GrConfigure />
              <WhenDesktop>Configure</WhenDesktop>
            </Space>
          </Button>
        </Space>
      )}
      {true === ebIntegrationInstalled && (
        <Space>
          <Button
            size='small'
            onClick={() => {
              setEventWidgetItemsForceReload(true);
            }}
            disabled={!eventWidgetItems || eventWidgetItemsForceReload}
          >
            <Space className='btn'>
              <MdRefresh />
              <WhenDesktop>Refresh</WhenDesktop>
            </Space>
          </Button>
          <Button
            size='small'
            onClick={() => {
              navigate('/security-advisor/events');
            }}
          >
            <Space className='btn'>
              <MdOutlineEventNote />
              <WhenDesktop>More</WhenDesktop>
            </Space>
          </Button>
        </Space>
      )}
    </>
  );
};

EventsWidgetBtns.propTypes = {};

export default EventsWidgetBtns;
